import { Form, Row, Col } from "react-bootstrap";

interface SeoFormSectionProps {
    data: any;
    onChange: (key: string, value: any) => void;
}

export const SeoFormSection = ({ data, onChange }: SeoFormSectionProps) => {
    return (
        <Col md={12} className="mb-4">
            <Form.Label className="generic-form-label mt-3">SEO & Meta Settings</Form.Label>
            <div className="p-3 border rounded bg-white shadow-sm">
                <Row>
                    <Col md={12} className="mb-3">
                        <Form.Group>
                            <Form.Label className="generic-form-label">SEO Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter SEO Title (e.g. Best Online Programs | Top Universities)"
                                value={data?.seoTitle || ''}
                                onChange={(e) => onChange('seoTitle', e.target.value)}
                                className="generic-form-control"
                            />
                        </Form.Group>
                    </Col>

                    <Col md={12} className="mb-3">
                        <Form.Group>
                            <Form.Label className="generic-form-label">Meta Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter Meta Description for search engines..."
                                value={data?.metaDescription || ''}
                                onChange={(e) => onChange('metaDescription', e.target.value)}
                                className="generic-form-control"
                            />
                        </Form.Group>
                    </Col>

                    <Col md={12} className="mb-3">
                        <Form.Group>
                            <Form.Label className="generic-form-label">Focus Keywords</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Comma-separated keywords (e.g. online mba, distance degree, accredited)"
                                value={data?.focusKeywords || ''}
                                onChange={(e) => onChange('focusKeywords', e.target.value)}
                                className="generic-form-control"
                            />
                        </Form.Group>
                    </Col>

                    <Col md={12}>
                        <Form.Group>
                            <Form.Label className="generic-form-label">Schema Markup (JSON-LD)</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                placeholder={`{\n  "@context": "https://schema.org",\n  "@type": "Course",\n  ...\n}`}
                                value={data?.schemaMarkup || ''}
                                onChange={(e) => onChange('schemaMarkup', e.target.value)}
                                className="generic-form-control"
                                style={{ fontFamily: 'monospace', fontSize: '13px' }}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            </div>
        </Col>
    );
};

